import { render, staticRenderFns } from "./admin-call-markaz.vue?vue&type=template&id=1af44b0d&scoped=true"
import script from "./admin-call-markaz.vue?vue&type=script&lang=js"
export * from "./admin-call-markaz.vue?vue&type=script&lang=js"
import style0 from "./admin-call-markaz.vue?vue&type=style&index=0&id=1af44b0d&prod&lang=scss"
import style1 from "./admin-call-markaz.vue?vue&type=style&index=1&id=1af44b0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af44b0d",
  null
  
)

export default component.exports